<template>
<div class="container-fluid">
  <div class="row pt-2 text-start mb-2">
      <div class="col-6">
          <h5>
              <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
              <b>Patients : รายชื่อคนไข้</b>
              </span>
          </h5>
      </div>
      <div class="col-6">
          <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#patientModal" @click="newRecord()" style="width:250px;">New</button>
          <!-- <div class="col float-end "> <input class="btn btn-primary" value="New" @click="newRecord()"></div> -->
      </div>
  </div>
  <div class="row ">
    <div class="col-sm">
        <table id="myPatTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;font-size:80%">
            <thead class="text-white" style="background:Navy">
            <tr>
                <!-- <th >รหัสคลินิก</th> -->
                <th>แก้ไข</th>
                <th>รหัสประจำตัว</th>
                <th>ชื่อ 1</th>
                <th>ชื่อ 2</th>
                <th>เลขบัตรประชาชน</th>
                <th>เพศ</th>
                <th>วันเกิด</th>
                <th>อายุ</th>
                <th>จังหวัด</th>
                <th>โทรศัพท์</th>
                <th>Email</th>
                <th title="เป็นคนต่างชาติ">ต่างชาติ</th>
                <th>Passport No.</th>
                <th>Country</th>
                <th>มาครั้งแรก</th>
                <th>ลบ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in datalists" :key="item.patid" v-bind:data-id="item.patid" @click="tableChanged(item)">
                <!-- <td class="text-start">{{ item.ReqClinicCode }}</td> -->
                <td>
                  <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#patientModal">Edit</button>
                </td>
                <td class="text-start">{{ item.PatCode }}</td>
                <td class="text-start">{{ item.PatName }} {{ item.PatLName }}</td>
                <td class="text-start">{{ item.PatName2 }} {{ item.PatLName2 }}</td>
                <td class="text-start">{{ item.IDNo }}</td>
                <td class="text-start">{{ arrSex[item.Sex] }}</td>
                <td class="text-start">{{ item.BirthDate }}</td>
                <td class="text-center">{{item.AgeYears}}</td>
                <td class="text-start">{{ item.Province }}</td>
                <td class="text-start">{{ item.Tel1 }}</td>
                <td class="text-start">{{ item.Email1 }}</td>
                <td class="text-center">{{ arrForeigner[item.Foreigner] }}</td>
                <td class="text-start">{{ item.PassportNo }}</td>
                <td class="text-start">{{ item.Country }}</td>
                <td class="text-start">{{ item.DateIN }}</td>
                <td>
                  <!-- <button class="btn btn-danger btn-sm " id="Delete" @click="alertConfirmYesNo('TEST')">test</button> -->
                  <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>

<!-- Modal Form -->
<div id="patientModal" class="modal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Patient : ป้อนรายชื่อคนไข้</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form id="fmPatient" @submit.prevent="" >
            <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
            <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
            <input type="text" hidden class="form-control" placeholder="" name="id" v-model="curRecord.PatID" >
            <div class="row mb-1">
                <div class="col-8 text-start">
                    <div class="input-group input-group-sm" title="ใช้เลขบัตรประชาชนได้หรือกดปุ่ม Auto เพื่อสร้างเลขประจำตัวคนไข้">
                      <span class="input-group-text" style="width:180px;">รหัสประจำตัวคนไข้ *</span>
                      <input type="text" class="form-control form-control-sm" ref="PatCode" name="patcode" v-model="curRecord.PatCode">
                      <button type="button" class="btn btn-info mx-1" @click="autoPatNO()" style="width:80px;" title="กดปุ่ม Auto เพื่อสร้างเลขประจำตัวคนไข้ (Format : Pyymm-nnnnnn เช่น P2301-000001)">Auto</button>
                    </div>
                </div>
                <div class="col-4 text-center" hidden>
                    <button type="button" class="btn btn-success " ref="btnReadIDCard" @click="btnReadIDCardClicked()"><i class="fa fa-address-card"></i> อ่านบัตรประชาชน</button>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col text-start">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:180px;">คำนำหน้า / ชื่อ* / นามสกุล*</span>
                      <input type="text" class="form-control form-control-sm" ref="Prefix" name="prefix" v-model="curRecord.PrefixName">
                      <input type="text" class="form-control form-control-sm" ref="PatName" name="patname" v-model="curRecord.PatName">
                      <input type="text" class="form-control form-control-sm" ref="PatLName" name="patlname" v-model="curRecord.PatLName">
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col text-start">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:180px;"> Prefix / First / last name</span>
                      <input type="text" class="form-control form-control-sm" name="prefix2" v-model="curRecord.PrefixName2">
                      <input type="text" class="form-control form-control-sm" name="patname2" v-model="curRecord.PatName2">
                      <input type="text" class="form-control form-control-sm" name="patlname2" v-model="curRecord.PatLName2">
                    </div>
                </div>
            </div>
            <!-- เลขบัตรปชช / เลขผู้เสียภาษี -->
            <div class="row mt-2 mb-2">
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="เลขบัตรประชาชน สำหรับพิมพ์ในใบผลแล็บ">
                  <span class="input-group-text" style="width:180px;">หมายเลขบัตรประชาชน</span>
                  <input type="text" class="form-control form-control-sm" ref="IDNo" name="idno" v-model="curRecord.IDNo">
                </div>
              </div>
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="เลขบัตรประชาชน สำหรับพิมพ์ในใบผลแล็บ">
                  <span class="input-group-text" style="width:120px;">เลขผู้เสียภาษี</span>
                  <input type="text" class="form-control form-control-sm" name="taxid" v-model="curRecord.TaxID">
                </div>
              </div>
            </div>
            <!-- เพศ / วันเกิด -->
            <div class="row mt-2 mb-2">
              <div class="col-6 text-start">
                <!-- <div class="input-group input-group-sm">
                    <span class="input-group-text" style="width:180px;">เพศ</span>
                    <div class="form-check form-check-inline py-1 ms-2">
                      <input class="form-check-input" type="radio" name="sex" id="inlineRadio1" value="1" v-model="curRecord.Sex">
                      <label class="form-check-label" for="inlineRadio1">ชาย</label>
                    </div>
                    <div class="form-check form-check-inline py-1">
                      <input class="form-check-input" type="radio" name="sex" id="inlineRadio2" value="2" v-model="curRecord.Sex">
                      <label class="form-check-label" for="inlineRadio2">หญิง</label>
                    </div>
                </div> -->
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:180px;">เพศ* :(1-ชาย,2-หญิง)</span>
                    </div>
                    <input type="number" class="form-control form-control-sm" ref="Sex" name="sex" v-model="curRecord.Sex"
                      min="1" max="2">
                </div>
              </div>
              <!-- วันเกิด -->
              <div class="col-6 text-start">
                <div class="input-group input-group-sm" title="ปี ค.ศ. รูปแบบ YYYY-MM-DD">
                  <span class="input-group-text" style="width:120px;">วันเกิด ค.ศ.</span>
                  <v-date-picker v-model="curRecord.BirthDate" :masks="masks"
                    @click="validBirtday(curRecord.BirthDate.toISOString().slice(0, 10))"
                    @change="validBirtday(curRecord.BirthDate.toISOString().slice(0, 10))">
                    <template v-slot="{ inputValue, inputEvents }">
                      <input name="birthdate" ref="BirthDate" @change="validBirtday(inputValue)"
                      class="bg-white border px-2 py-1 rounded" style="width:120px;"
                      :value="inputValue"
                      v-on="inputEvents"
                      />
                    </template>
                  </v-date-picker>
                  <span class="input-group-text ms-2 px-2 py-1" v-if="_agePat>0">อายุ {{_agePat}} ปี</span>
                </div>
                <div>
                  <span class="input-group-text px-2 py-1" style="width:120px; font-size:80%;">พ.ศ.{{_birthDayBC}}</span>
                </div>
              </div>
            </div>
            <!-- ที่อยู่ -->
            <div class="row mb-1">
              <div class="col text-start">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text" style="width:180px;"> ที่อยู่</span>
                    <input type="text" class="form-control form-control-sm" name="addr1" v-model="curRecord.Addr1">
                  </div>
              </div>
            </div>
            <!-- ตำบล / อำเภอ / จังหวัด -->
            <div class="row mb-1">
                <div class="col text-start">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:180px;"> ตำบล / อำเภอ / จังหวัด</span>
                      <input type="text" class="form-control form-control-sm" name="tambon" v-model="curRecord.Tambon">
                      <input type="text" class="form-control form-control-sm" name="amphor" v-model="curRecord.Amphor">
                      <input type="text" class="form-control form-control-sm" name="province" v-model="curRecord.Province">
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6 text-start">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:180px;"> รหัสไปรษณีย์</span>
                      <input type="text" class="form-control form-control-sm" name="postcode" v-model="curRecord.PostCode">
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <!-- โทรศัพท์ / Email -->
                <div class="col-6 text-start p-2">
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">โทรศัพท์#1 </span>
                      <input type="text" class="form-control form-control-sm" name="tel1" v-model="curRecord.Tel1">
                    </div>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">โทรศัพท์#2 </span>
                      <input type="text" class="form-control form-control-sm" name="tel2" v-model="curRecord.Tel2">
                    </div>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">Email#1 </span>
                      <input type="text" class="form-control form-control-sm" name="email1" v-model="curRecord.Email1">
                    </div>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:180px;">Email#2 </span>
                      <input type="text" class="form-control form-control-sm" name="email2" v-model="curRecord.Email2">
                    </div>
                </div>
                <!-- นน/ส่วนสูง/ชีพจร/ความดันโลหิต -->
                <div class="col-6 text-start p-2" style="background-color:Beige;" hidden>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">น้ำหนัก</span>
                      <input type="number" class="form-control form-control-sm me-2" ref="IDNo" name="weight" v-model="curRecord.Weight" style="width:60px;">
                      <span class="mt-1">KG.</span>
                    </div>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">ส่วนสูง</span>
                      <input type="number" class="form-control form-control-sm me-2" name="height" v-model="curRecord.Height">
                      <span class="mt-1">cm.</span>
                    </div>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">ชีพจร</span>
                      <input type="number" class="form-control form-control-sm me-2" ref="Pulse" name="pulse" v-model="curRecord.Pulse">
                      <span class="mt-1">ครั้งต่อนาที</span>
                    </div>
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:180px;">ความดันโลหิต</span>
                      <input type="number" class="form-control form-control-sm me-1" name="bp_1" v-model="curRecord.BP_1">
                      <span class="mt-1 me-1">/</span>
                      <input type="number" class="form-control form-control-sm me-1" name="bp_2" v-model="curRecord.BP_2">
                      <span class="mt-1">mmHg</span>
                    </div>
                </div>
            </div>

            <!-- เป็นคนต่างชาติ -->
            <div class="row mt-2 mb-1">
              <div class="col-6 text-start" >
                <div class="form-check form-check-inline mx-3 pt-2" title="คลิกเลือกถ้าเป็นคนต่างชาติ ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" ref="Foreigner" name="foreigner"
                     :checked="curRecord.Foreigner==1"  value="1" v-model="curRecord.Foreigner">
                  <label class="form-check-label" for="inlineCheckbox1"> เป็นคนต่างชาติ </label>
                </div>
              </div>
            </div>
            <!-- เชื้อชาติ / สัญชาติ -->
            <div class="row mb-1">
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="เป็นคนเชื้อชาติอะไร">
                  <span class="input-group-text" style="width:180px;">เชื้อชาติ</span>
                  <input type="text" class="form-control form-control-sm" ref="Race" name="race" v-model="curRecord.Race">
                </div>
              </div>
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="สัญชาติ">
                  <span class="input-group-text" style="width:120px;">สัญชาติ</span>
                  <input type="text" class="form-control form-control-sm" name="nationality" v-model="curRecord.Nationality">
                </div>
              </div>
            </div>
            <!-- พาสพอร์ตนัมเบอร์ / ประเทศที่มา -->
            <div class="row mb-3">
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="หมายเลขหนังสือเดินทาง">
                  <span class="input-group-text" style="width:180px;">หมายเลขหนังสือเดินทาง</span>
                  <input type="text" class="form-control form-control-sm" ref="PassportNo" name="passportno" v-model="curRecord.PassportNo">
                </div>
              </div>
              <div class="col-6 text-start" >
                <div class="input-group input-group-sm" title="ประเทศ (ที่มา)">
                  <span class="input-group-text" style="width:120px;">ประเทศ</span>
                  <input type="text" class="form-control form-control-sm" name="country" v-model="curRecord.Country">
                </div>
              </div>
            </div>

            <!-- โรคประจำตัว / ยาที่แพ้ -->
            <div class="row mb-1">
              <div class="col text-start">
                  <div class="input-group input-group-sm">
                  <span class="input-group-text text-danger" style="width:180px;">โรคประจำตัว (ถ้ามี)</span>
                  <input type="text" class="form-control form-control-sm" ref="CongDisease" name="congdisease" v-model="curRecord.CongDisease">
                  </div>
              </div>
            </div>
            <!-- ยาที่แพ้ (ถ้ามี) -->
            <div class="row mb-1">
              <div class="col text-start" >
                <div class="input-group input-group-sm" title="ระบุรายชื่อยาที่แพ้ (Drug Allergy)">
                  <span class="input-group-text text-danger" style="width:180px;">ยาที่แพ้ (ถ้ามี)</span>
                  <input type="text" class="form-control form-control-sm" ref="DrugAllergy" name="drugallergy" v-model="curRecord.DrugAllergy">
                </div>
              </div>
            </div>
            <br>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" ref="btnCloseModal" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="saveData()">Save changes</button>
        <!-- <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button> -->
      </div>
    </div>
  </div>
</div>

</template>

<script>
// import axios from 'axios'
import myfuncs from '../myjs/myfuncs.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import * as myIDCard from '../myjs/personcard.js'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'MPatients1View',
  components: {

  },
  data () {
    return {
      arrForeigner: ['', 'Y'],
      arrSex: ['', 'ชาย', 'หญิง'],
      lastPatNo: null,
      datalists: null,
      // provinceRows: [],
      curRecord: {
        PatCode: '',
        PrefixName: '',
        PatName: '',
        PatLName: '',
        IDNo: ''
      },
      action: 'new',
      masks: {
        input: 'YYYY-MM-DD'
        // input: 'DD-MM-YYYY'
      },

      IDCardInfo: {},
      soundFile: require('@/sound/beep-07a.mp3'),
      myVar: null
    }
  },
  mounted () {
    this.getData()
    // alert(myFoo(5, 20))
    // alert(myIDCard.MY_CONST)
    // myIDCard.setMyVariable({ no: 1 })
    // alert('setMyVariable to {no: 1}')
  },
  computed: {
    // a computed getter
    _agePat: function () {
      if (this.curRecord.BirthDate == null) { return 0 }
      return myfuncs.calculateAge(new Date(this.curRecord.BirthDate))
    },
    _birthDayBC: function () {
      if (typeof this.curRecord.BirthDate === 'undefined' || this.curRecord.BirthDate === null) {
        return null
      }
      var newDateAD
      if (myfuncs.isBEBirthDate(new Date(this.curRecord.BirthDate))) {
        newDateAD = myfuncs.DateBE2AD(this.curRecord.BirthDate)
      } else {
        newDateAD = this.curRecord.BirthDate
      }
      return new Date(newDateAD).toLocaleString('th-TH', { year: 'numeric', month: '2-digit', day: '2-digit' })
    }
  },
  methods: {
    autoPatNO () {
      let NewPatNo = ''
      // ====================================
      // 1. call fnc. get_prefix : PYYMM
      // 2. call MyApiClient.get
      // 3. call fnc. gen_newpatno
      // ====================================
      // 1.
      let prefix = ''
      prefix = myfuncs.genPatNo_getPrefix(this.globalCorpID)
      // 2.
      MyApiClient.get('getdata/getlast_patno_prefix.php?C1=' + this.globalCorpID + '&prefix=' + prefix)
        .then((resp) => {
          let lastPatNo = ''
          lastPatNo = resp.data.response[0].LastPatNo
          // 3.
          NewPatNo = myfuncs.genPatNo_New(prefix, lastPatNo)
          this.curRecord.PatCode = NewPatNo
          // console.log(NewPatNo)
        })
        .catch((err) => {
          console.log(err.response)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถดึงเลขที่เอกสารล่าสุดได้' })
        })
    },
    // validBirtday (datestr) {
    //   // ถ้าไม่ใช่ YYYY-MM-DD ให้แปลงเป็น YYYY-MM-DD
    //   if (!this.isValidDate(datestr)) {
    //     this.curRecord.BirthDate = this.convertDMY2YMD(datestr)
    //     console.log(' -> INVALID DATE!!')
    //   } else {
    //     console.log(' -> VALID DATE')
    //   }
    // },
    // ถ้าไม่ใช่ YYYY-MM-DD ให้แปลงเป็น YYYY-MM-DD
    // validBirtday (datestr) {
    //   var newDateAD, newDateADstr
    //   if (myfuncs.isBEBirthDate(new Date(datestr))) {
    //     console.log(' -> 01')
    //     newDateAD = myfuncs.DateBE2AD(new Date(datestr))
    //     newDateADstr = newDateAD.toISOString().slice(0, 10)
    //   } else {
    //     console.log(' -> 02')
    //     newDateADstr = datestr
    //   }
    //   if (!this.isValidDate(newDateADstr)) {
    //     console.log(' -> 03')
    //     this.curRecord.BirthDate = this.convertDMY2YMD(newDateADstr)
    //     // console.log(newDateADstr + ' -> INVALID DATE!!')
    //   } else {
    //     console.log(' -> 04')
    //     this.curRecord.BirthDate = new Date(newDateADstr)
    //     // console.log(newDateADstr + ' -> VALID DATE')
    //   }
    // },
    validBirtday (datestr) {
      // alert('On Valid วันเกิด')
      var newDateAD, newDateADstr
      // 1. Format Date ไม่เป็น YYYY-MM-DD
      if (!this.isValidDate(datestr)) {
        // 2. แปลงเป็น YYYY-MM-DD และ Check ว่าเป็น พ.ศ. หรือไม่?
        if (myfuncs.isBEBirthDate(this.convertDMY2YMD(datestr))) {
          // 3. แปลงวันเกิด พ.ศ. เป็น ค.ศ.
          newDateAD = myfuncs.DateBE2AD(this.convertDMY2YMD(datestr))
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        } else {
          // 4. เป็นวันเกิด ค.ศ. อยู่แล้ว (แต่ป้อนมาเป็น DD-MM-YYYY)
          newDateAD = this.convertDMY2YMD(datestr)
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        }
      } else { // ป้อนมาเป็น YYYY-MM-DD
        // Check ว่าเป็น พ.ศ. หรือไม่?
        if (myfuncs.isBEBirthDate(new Date(datestr))) {
          // 3. แปลงวันเกิด พ.ศ. เป็น ค.ศ.
          newDateAD = myfuncs.DateBE2AD(new Date(datestr))
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        } else {
          // 4. เป็นวันเกิด YYYY-MM-DD และเป็น ค.ศ. อยู่แล้ว
          newDateAD = new Date(datestr)
          newDateADstr = newDateAD.toISOString().slice(0, 10)
        }
      }
      this.curRecord.BirthDate = new Date(newDateADstr)
    },
    // =========================
    // ใช้ฟังก์ชั่นจากไฟล์ร่วม .js
    isValidDate (datestring) {
      return myfuncs.isValidDate(datestring)
    },
    convertDMY2YMD (datestring) {
      return myfuncs.convertDMY2YMD(datestring)
    },
    // =========================
    alertConfirmYesNo (textStr) {
      var r = confirm(textStr + '\n\n กด "OK" ถ้าต้องการบันทึกข้อมูล')
      if (r === true) {
        return true
      } else {
        return false
      }
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.PatName + ' ' + item.PatLName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_patient.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_patient.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_patient.php',
            data: { id: item.PatID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
            //   self.getData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {
        PatCode: '',
        PrefixName: '',
        PatName: '',
        PatLName: '',
        IDNo: ''
      }
      this.action = 'new'
      this.curRecord.Sex = 1

      this.$refs.PatCode.focus()
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    getData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/patient_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myPatTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    checkFieldsBeforeSave () {
      if ((this.curRecord.PatCode === '')) {
        this.$refs.PatCode.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "รหัสประจำตัวคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.PrefixName === '')) {
        this.$refs.Prefix.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "คำนำหน้าชื่อคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.PatName === '')) {
        this.$refs.PatName.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชื่อคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.PatLName === '')) {
        this.$refs.PatLName.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "นามสกุลคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.IDNo === '')) {
        if (!(this.alertConfirmYesNo('หมายเลขประจำตัวบัตรประชาชนไม่มีข้อมูล!'))) {
          this.$refs.IDNo.focus()
          Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "หมายเลขบัตรประชาชน" ', showConfirmButton: false, timer: 1500 })
          return false
        }
      }
      if ((this.curRecord.Sex === '' || this.curRecord.Sex < 1 || this.curRecord.Sex > 2)) {
        this.$refs.Sex.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เพศคนไข้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      return true
    },
    saveData () {
      var self = this
      if (this.checkFieldsBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        var x = $('#fmPatient').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // console.log(formData)
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/insert_patient.php',
          // url: 'http://localhost/vmedlab/src/service/setdata/insert_patient.php',
          // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/insert_patient.php',
          data: { request: JSON.stringify(formData) }
        })
          .done(function (resp) {
            var elem = self.$refs.btnCloseModal
            elem.click()
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              // Refresh >> this component only
              // this.$refs.getData()
              // self.getData()
              self.$emit('onDataChangedEvent')
              // location.reload()
              // this.$router.push('MClinics')
            })
          })
          .fail(function (resp) {
            // alert('Not Saved')
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    // ======================== BEGIN : SMART CARD READER ===================== //
    playSound (sound) {
      if (sound) {
        var audio = new Audio(sound)
        audio.play()
      }
    },
    btnReadIDCardClicked () {
      this.startRead()
      // this.loadData()
    },
    setIDCardInfo (jdata) {
      this.IDCardInfo = jdata
      this.curRecord.PatCode = jdata.CitizenNo
      this.curRecord.PrefixName = jdata.TitleNameTh
      this.curRecord.PatName = jdata.FirstNameTh
      this.curRecord.PatLName = jdata.LastNameTh
      this.curRecord.PrefixName2 = jdata.TitleNameEn
      this.curRecord.PatName2 = jdata.FirstNameEn
      this.curRecord.PatLName2 = jdata.LastNameEn
      this.curRecord.IDNo = jdata.CitizenNo
      this.curRecord.TaxID = ''
      this.curRecord.Sex = jdata.Gender
      this.curRecord.BirthDate = new Date(parseInt(jdata.BirthDate.substr(0, 4)) - 543, parseInt(jdata.BirthDate.substr(4, 2)) - 1, parseInt(jdata.BirthDate.substr(6, 2)))
      this.curRecord.Addr1 = jdata.HomeNo + ' ' + jdata.Moo + ' ' + jdata.Soi + ' ' + jdata.TitleRoad + jdata.Road
      this.curRecord.Tambon = jdata.TitleTumbol + jdata.Tumbol
      this.curRecord.Amphor = jdata.TitleAmphur + jdata.Amphur
      this.curRecord.Province = jdata.TitleProvince + jdata.Province
      this.curRecord.PostCode = ''
    },
    startRead () {
      this.myStopFunction()
      this.myVar = setInterval(this.loadData, 1500)
    },
    myStopFunction () {
      clearInterval(this.myVar)
    },
    loadData () {
      var self = this
      this.myStopFunction()
      var jdata = null
      $.ajax({
        url: 'https://localhost:8182/thaiid/read.jsonp?callback=callback&section1=true&section2a=true&section2c=true',
        method: 'GET',
        type: 'JSON',
        success: function (jsondata) {
          var data = jsondata.substr(13, jsondata.length - 14)
          jdata = JSON.parse(data)
          if (jdata !== null) {
            self.playSound(self.soundFile)
            // console.log(jdata)
            self.setIDCardInfo(jdata)
            // setTimeout(function () { checkDataCard(jdata.CitizenNo, jdata) }, 500)
          } else {
            $.busyLoadFull('hide')
            this.startRead()
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $.busyLoadFull('hide')
          Swal.fire({
            type: 'warning',
            title: 'ลองใหม่อีกครั้ง',
            text: 'กรุณาทำการอ่านบัตรใหม่อีกครั้ง!' + textStatus
          }).then((res) => {
            this.startRead()
          })
        }
      })
    }
    // ========================= END : SMART CARD READER ===================== //
  }
}
</script>

<style>

</style>
